import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { useLeads } from "@/store/useLeads";


export default /*@__PURE__*/_defineComponent({
  __name: 'filter-header',
  props: {
	activeToggleMain: Boolean,
	activeToggleThree: Boolean,
},
  emits: ["sortChanged"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const leadsStore    =    useLeads();

const props = __props;

const activeMain = ref(props.activeToggleMain);
const activeThree = ref(props.activeToggleThree);

const emit = __emit;

const isActive = ref(false);

const showHidden = () => {
	// leadsStore.showHidden();
	leadsStore.toggleHiddenLeads();
	isActive.value = !isActive.value;
};

const sortBy = () => {
	const sortedList = [...useLeads().leadsList];

	if (activeMain.value) {
		sortedList.sort((a, b) =>
			(activeThree.value
				? new Date(a.lastContact).getTime() - new Date(b.lastContact).getTime()
				: new Date(b.lastContact).getTime() - new Date(a.lastContact).getTime())
		);
	} else {
		sortedList.sort((a, b) =>
			a.name.fullName.localeCompare(b.name.fullName)
		);

		if (activeThree.value) sortedList.reverse();
	}

	emit("sortChanged", sortedList);
};

watch([activeMain, activeThree], sortBy);

const __returned__ = { leadsStore, props, activeMain, activeThree, emit, isActive, showHidden, sortBy, ref, computed, watch, get useLeads() { return useLeads } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})